import { createIconSetFromIcoMoon } from '@expo/vector-icons';

import icoMoonConfig from '../icomoon/selection.json'

const expoAssetId = require("../icomoon/fonts/icomoon.ttf");


export default createIconSetFromIcoMoon(icoMoonConfig, 'icomoon', expoAssetId);